import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';

import { SingleInput } from '../../Res/BaseInput';
import { ReqSalaryItem } from '../../../../item/ItemContractorAttendance_RecruitmentItem_SalaryBase';

export const ContractorAttendanceDailogSalarySubtractAmount = forwardRef((props, ref) => {
    const [SalarySubtractAmount, setSalarySubtractAmount] = useState(0)
    const [SalarySubtractItems, setSalarySubtractItems] = useState([])

    useEffect(() => {
        if (props.obj !== undefined && props.obj !== SalarySubtractItems) {
            setSalarySubtractAmount(props.SalarySubtractAmount)
            setSalarySubtractItems(JSON.parse(props.obj))
        }
    }, [props.obj])

    // useEffect(() => {
    //     // console.log(props)
    //     console.log(SalarySubtractAmount)
    // })

    function setSalarySubtractItem(salarySubtractItem) {
        var change = false
        var amounts = 0
        SalarySubtractItems.forEach((item, index, arr) => {
            if (item.key === salarySubtractItem.key) {
                arr[index] = salarySubtractItem
                change = true
            }
            amounts += arr[index].amount
        });
        if (change) {
            // console.log(AbsenceItems)
            setSalarySubtractItems(JSON.parse(JSON.stringify(SalarySubtractItems)))
            setSalarySubtractAmount(amounts)
        }
    }

    useImperativeHandle(ref, () => ({
        send: () => {
            props.action({ SalarySubtractItems, SalarySubtractAmount })
        }
    }));
    return (
        <table className="table table-striped table-bordered table-hover  dataTable">
            <thead>
                <tr role="row">
                    <th className="text-center sorting col-sm-4">項目名稱</th>
                    <th className="text-right sorting col-sm-4">金額</th>
                </tr>
                {
                    SalarySubtractItems.map((salarySubtractItem) => (
                        <DailogAbsenceAmoutItem key={salarySubtractItem.key} salarySubtractItem={salarySubtractItem} action={setSalarySubtractItem} />
                    ))
                }
                <tr role="row">
                    <td className="text-center">加項總金額</td>
                    <td className="text-right"><span className="text-success">{SalarySubtractAmount}</span></td>
                </tr>
            </thead>
        </table>
    )
})

function DailogAbsenceAmoutItem({ salarySubtractItem, action }) {
    const [mSalarySubtractItem, setASsalarySubtractItem] = useState({})
    const [name, setName] = useState("")
    const [amount, setAmount] = useState(0)

    const [init, setInit] = useState(true)

    useEffect(() => {
        console.log(salarySubtractItem)
        if (salarySubtractItem !== undefined && Object.keys(salarySubtractItem).length !== 0 && salarySubtractItem !== mSalarySubtractItem) {

            var item = new ReqSalaryItem({})
            item.fromJson(salarySubtractItem)

            setName(item.name)
            setAmount(item.amount)
            setASsalarySubtractItem(item)
            // console.log(item)
        }
    }, [salarySubtractItem])

    useEffect(() => {
        console.log(amount)
        if (init) {
            setInit(false)
        } else {
            var item = Combination(salarySubtractItem)
            action(item)
        }
    }, [amount])

    function Combination(salarySubtractItem) {
        var item = new ReqSalaryItem({})
        item.fromJson(salarySubtractItem)
        setAmount(item.amount)
        setASsalarySubtractItem(JSON.parse(JSON.stringify(item)))
        return item
    }

    function inputAmount(amount) {
        // console.log(amount)
        var item = new ReqSalaryItem({})
        item.fromJson(salarySubtractItem)
        item.setAmount(amount)
        setAmount(item.amount)
        setASsalarySubtractItem(JSON.parse(JSON.stringify(item)))
        action(item)
    }

    return (

        <tr role="row">
            <td className="text-center">{name}</td>
            <td className="text-right">
                <SingleInput val={amount} action={inputAmount} placeholder={176} size={12} type={"number"} isRight={true} />
            </td>
        </tr>
    )
}